interface RewardType {
  type: 'SWISS_LOYALTY';
  value: number;
}

export enum ReferralCampaignType {
  SWISSCARD = 'SWISSCARD',
  AFFILIATE = 'AFFILIATE'
}

export enum ReferralStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED'
}

export interface ReferralLink {
  id: number;
  link: string;
  code: string;
  language: string;
  campaign: PublicReferralCampaign;
  created: Date;
  createdBy: number;
  createdByAdmin: string;
}

export interface Referral {
  id: number;
  referralLink: ReferralLink;
  status: ReferralStatus;
  created: Date;
}

export interface PublicReferralCampaign {
  id: number;
  name: string;
  description: string;
  terms: string;
  label: string;
  maxAmountOfReferrals: number;
  referrerReward: RewardType;
  referralReward: RewardType;
  active: boolean;
  startDate: Date;
  endDate: Date;
  type: ReferralCampaignType;
  recipientName: string;
  recipientDescription: string;
  recipientMessage: string;
  created: Date;
  createdBy: number;
  modified: Date;
  modifiedBy: number;
  hidden: boolean;
}

export enum ReferralCampaignsLoadStatus {
  NOT_LOADED = 'NOT_LOADED',
  LOADING = 'LOADING',
  LOADED = 'LOADED'
}
